module.exports = __webpack_public_path__ + "static/media/Facebook.4240dd5e.svg";